/**
 * @file: com.zhichetech.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { OEMConfig } from '../types';

export const __oemConfig__: OEMConfig = {
  shortName: '知车',
  fullName: '四川知车科技有限公司',
  website: 'https://www.zhichetech.com',
  slogon: '汽车后市场产业数字化技术服务专家',
  description: [
    '四川知车科技有限公司（简称：知车科技）成立于2019年8月，是汽车后市场产业数字化技术服务商。 ',
    '专注于汽车售后服务领域，以汽车数据化检测为基础，提供车辆数据采集、存储、分析及应用等服务。 ',
    '致力于解决汽车后市场同质化恶性竞争、标准缺失、信任危机等问题，通过技术创新和数据应用实现产业数字化、网络化、智能化。',
  ].join(''),
};
